import { z } from "zod";

export const postMetricsSchema = z.object({
  metrics: z.array(
    z.object({
      metric: z.string(),
      label: z.string(),
    })
  ),
});
